<div class="flex flex-col gap-y-4">

  <!-- Header: Filters -->
  <div class="bg-white rounded-xl shadow-sm p-5">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <app-custom-dropdown
        label="Sucursal"
        [(ngModel)]="filters.office_id"
        [options]="offices"
        optionLabel="name"
        optionValue="id"
        placeholder="Todas"
        (onChange)="loadMonthData()">
      </app-custom-dropdown>

      <app-custom-dropdown
        label="Profesor"
        [(ngModel)]="filters.teacher_id"
        [options]="teachers"
        optionLabel="name"
        optionValue="id"
        placeholder="Todos"
        (onChange)="loadMonthData()">
      </app-custom-dropdown>

      <app-custom-dropdown
        label="Carnet"
        [(ngModel)]="filters.license_id"
        [options]="licenses"
        optionLabel="name"
        optionValue="id"
        placeholder="Todos"
        (onChange)="loadMonthData()">
      </app-custom-dropdown>
    </div>
  </div>

  <!-- Two-column layout: Mini Calendar + Day Detail -->
  <div class="flex gap-4 items-start">

    <!-- LEFT: Mini Calendar (~380px), sticky -->
    <div class="w-[380px] flex-shrink-0 bg-white rounded-xl shadow-sm p-5 sticky top-16 self-start">

      <!-- Month navigation -->
      <div class="flex items-center justify-between mb-4">
        <button (click)="prevMonth()"
          class="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-500 hover:text-gray-700 transition-colors"
          title="Mes anterior">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
        </button>
        <span class="text-base font-semibold text-gray-800">{{ monthLabel }}</span>
        <button (click)="nextMonth()"
          class="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-500 hover:text-gray-700 transition-colors"
          title="Mes siguiente">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
          </svg>
        </button>
      </div>

      <!-- Today button -->
      <div class="flex justify-center mb-4">
        <button (click)="goToToday()"
          class="px-4 py-1.5 text-xs font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-red-600 hover:text-white transition-all">
          Hoy
        </button>
      </div>

      <!-- Loading -->
      <div *ngIf="loading" class="flex items-center justify-center py-8">
        <svg class="animate-spin h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
        </svg>
      </div>

      <!-- Day headers -->
      <div *ngIf="!loading" class="grid grid-cols-7 mb-1.5">
        <div *ngFor="let day of ['Lun','Mar','Mi\u00e9','Jue','Vie','S\u00e1b','Dom']"
          class="text-center text-[11px] font-semibold text-gray-400 uppercase py-1.5">
          {{ day }}
        </div>
      </div>

      <!-- Mini calendar grid -->
      <div *ngIf="!loading" class="grid grid-cols-7 gap-y-1">
        <div *ngFor="let cell of calendarDays"
          (click)="cell.isCurrentMonth && selectDay(cell)"
          class="flex flex-col items-center justify-center py-1 transition-all"
          [ngClass]="{
            'cursor-default': !cell.isCurrentMonth,
            'cursor-pointer': cell.isCurrentMonth
          }">
          <!-- Day number with circular highlight -->
          <span class="w-8 h-8 flex items-center justify-center rounded-full text-sm transition-colors"
            [ngClass]="{
              'text-gray-300': !cell.isCurrentMonth,
              'bg-red-600 text-white font-bold': selectedDay && selectedDay.date.getTime() === cell.date.getTime(),
              'ring-2 ring-red-400 text-red-600 font-semibold': cell.isToday && !(selectedDay && selectedDay.date.getTime() === cell.date.getTime()),
              'text-gray-700 font-medium hover:bg-gray-100': cell.isCurrentMonth && !cell.isToday && !(selectedDay && selectedDay.date.getTime() === cell.date.getTime())
            }">
            {{ cell.dayNumber }}
          </span>
          <!-- Color dots -->
          <div class="flex items-center gap-0.5 mt-0.5 h-[6px]">
            <span *ngIf="cell.summary?.by_type?.Abierto" class="w-1.5 h-1.5 rounded-full bg-green-400"></span>
            <span *ngIf="cell.summary?.by_type?.Maniobras" class="w-1.5 h-1.5 rounded-full bg-orange-400"></span>
            <span *ngIf="cell.summary?.by_type?.Examen" class="w-1.5 h-1.5 rounded-full bg-red-400"></span>
          </div>
        </div>
      </div>

      <!-- Legend -->
      <div *ngIf="!loading" class="mt-5 pt-3 border-t border-gray-100">
        <div class="flex flex-wrap items-center gap-4">
          <div class="flex items-center gap-1.5">
            <span class="w-2.5 h-2.5 rounded-full bg-green-400"></span>
            <span class="text-xs text-gray-500">Abierto</span>
          </div>
          <div class="flex items-center gap-1.5">
            <span class="w-2.5 h-2.5 rounded-full bg-orange-400"></span>
            <span class="text-xs text-gray-500">Maniobras</span>
          </div>
          <div class="flex items-center gap-1.5">
            <span class="w-2.5 h-2.5 rounded-full bg-red-400"></span>
            <span class="text-xs text-gray-500">Examen</span>
          </div>
        </div>
      </div>
    </div>

    <!-- RIGHT: Day Detail Panel -->
    <div class="flex-1 min-w-0 bg-white rounded-xl shadow-sm">

      <!-- No day selected state -->
      <div *ngIf="!selectedDay" class="flex flex-col items-center justify-center py-20 text-gray-400">
        <svg class="w-12 h-12 mb-3 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
        </svg>
        <p class="text-sm font-medium">Selecciona un dia en el calendario</p>
        <p class="text-xs mt-1">Haz clic en un dia para ver sus clases</p>
      </div>

      <!-- Day selected -->
      <div *ngIf="selectedDay" class="p-5">
        <!-- Header -->
        <div class="flex items-center justify-between mb-4">
          <div>
            <h3 class="text-lg font-bold text-gray-800">{{ getSelectedDayLabel() }}</h3>
            <p class="text-xs text-gray-500 mt-0.5">{{ dayDetailSchedules.length }} clases programadas</p>
          </div>
          <div class="flex items-center gap-2">
            <button (click)="toggleAllTeachers()"
              class="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-all"
              [title]="allTeachersCollapsed ? 'Expandir profesores' : 'Replegar profesores'">
              <svg class="w-3.5 h-3.5 transition-transform duration-200" [ngClass]="{ '-rotate-90': allTeachersCollapsed }"
                fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"></path>
              </svg>
              {{ allTeachersCollapsed ? 'Expandir' : 'Replegar' }}
            </button>
            <button (click)="navigateToCuadrante(selectedDay.date)"
              class="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-red-600 hover:text-white transition-all">
              <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Ver cuadrante
            </button>
          </div>
        </div>

        <!-- Summary badges by type -->
        <div *ngIf="daySummaryByType.length > 0" class="flex flex-wrap gap-2 mb-5">
          <div *ngFor="let item of daySummaryByType"
            class="flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700">
            <span class="w-2 h-2 rounded-full" [style.background-color]="item.color"></span>
            {{ item.count }} {{ item.type }}
          </div>
        </div>

        <!-- Loading -->
        <div *ngIf="loadingDetail" class="py-10 text-center">
          <div class="flex items-center justify-center gap-3 text-gray-400">
            <svg class="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
            </svg>
            <span class="text-sm">Cargando detalles...</span>
          </div>
        </div>

        <!-- Empty state -->
        <div *ngIf="!loadingDetail && dayDetailSchedules.length === 0" class="py-10 text-center text-gray-400">
          <svg class="w-10 h-10 mx-auto mb-2 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
          </svg>
          <p class="text-sm">No hay clases programadas para este dia</p>
        </div>

        <!-- Grouped schedules: License > Teacher > Schedules -->
        <div *ngIf="!loadingDetail && dayDetailSchedules.length > 0" class="space-y-6">
          <div *ngFor="let licenseGroup of groupedSchedules">

            <!-- License header (clickable to collapse/expand) -->
            <button type="button" (click)="toggleLicense(licenseGroup.licenseName)"
              class="w-full flex items-center gap-2 mb-3 cursor-pointer group/license">
              <svg class="w-4 h-4 text-gray-400 transition-transform duration-200 flex-shrink-0"
                [ngClass]="{ '-rotate-90': isLicenseCollapsed(licenseGroup.licenseName) }"
                fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"></path>
              </svg>
              <span class="text-base font-bold text-gray-800 group-hover/license:text-gray-900 transition-colors">Carnet {{ licenseGroup.licenseName }}</span>
              <span class="text-xs text-gray-400">({{ licenseGroup.totalCount }} clases)</span>
            </button>

            <!-- License content (collapsible) -->
            <div *ngIf="!isLicenseCollapsed(licenseGroup.licenseName)" class="ml-6 space-y-4">
              <div *ngFor="let teacherGroup of licenseGroup.teacherGroups">

                <!-- Teacher sub-header (clickable to collapse/expand) -->
                <button type="button" (click)="toggleTeacher(teacherGroup.teacherKey)"
                  class="w-full flex items-center gap-2 mb-1.5 cursor-pointer group/teacher">
                  <svg class="w-3.5 h-3.5 text-gray-400 transition-transform duration-200 flex-shrink-0"
                    [ngClass]="{ '-rotate-90': isTeacherCollapsed(teacherGroup.teacherKey) }"
                    fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"></path>
                  </svg>
                  <div class="w-6 h-6 rounded-full bg-gray-700 flex items-center justify-center flex-shrink-0">
                    <span class="text-[10px] font-bold text-white uppercase">{{ teacherGroup.teacherName.charAt(0) }}</span>
                  </div>
                  <span class="text-xs font-semibold text-gray-500 uppercase tracking-wide group-hover/teacher:text-gray-700 transition-colors">{{ teacherGroup.teacherName }}</span>
                  <span class="text-[10px] text-gray-400">({{ teacherGroup.schedules.length }})</span>
                </button>

                <!-- Schedule items (collapsible) -->
                <div *ngIf="!isTeacherCollapsed(teacherGroup.teacherKey)" class="space-y-1.5 ml-8">
                  <div *ngFor="let schedule of teacherGroup.schedules"
                    class="flex items-center gap-3 p-2.5 rounded-lg border border-gray-100 hover:border-gray-200 hover:bg-gray-50/50 transition-all">

                    <!-- Type color bar -->
                    <div class="w-1 h-10 rounded-full flex-shrink-0"
                      [style.background-color]="getTypeColor(schedule.is_exam ? 'Examen' : schedule.practice_type)">
                    </div>

                    <!-- Time -->
                    <div class="flex-shrink-0">
                      <span class="text-base font-bold text-gray-800">
                        {{ schedule.start_time?.substring(0,5) }}
                      </span>
                      <span class="text-xs text-gray-400 mx-0.5">-</span>
                      <span class="text-sm text-gray-500">
                        {{ schedule.end_time?.substring(0,5) }}
                      </span>
                    </div>

                    <!-- Type badge -->
                    <span class="px-2 py-0.5 rounded-full text-[10px] font-semibold flex-shrink-0"
                      [ngClass]="{
                        'bg-green-100 text-green-700': schedule.practice_type === 'Abierto' && !schedule.is_exam,
                        'bg-orange-100 text-orange-700': schedule.practice_type === 'Maniobras' && !schedule.is_exam,
                        'bg-red-100 text-red-700': schedule.is_exam
                      }">
                      {{ schedule.is_exam ? 'Examen' : schedule.practice_type }}
                    </span>

                    <!-- Details -->
                    <div class="flex-1 min-w-0 flex items-center gap-2 text-xs text-gray-500">
                      <span *ngIf="schedule.vehicle" class="flex items-center gap-1 truncate">
                        <svg class="w-3 h-3 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M8 17h.01M16 17h.01M3 11l1.5-5A2 2 0 016.4 4h11.2a2 2 0 011.9 1.4L21 11M3 11h18M3 11v6a1 1 0 001 1h1a2 2 0 104 0h6a2 2 0 104 0h1a1 1 0 001-1v-6" />
                        </svg>
                        {{ schedule.vehicle.model || schedule.vehicle.brand }}
                      </span>
                      <span *ngIf="schedule.bookings" class="flex items-center gap-1">
                        <svg class="w-3 h-3 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
                        </svg>
                        {{ schedule.bookings.length }}/{{ schedule.max_students }}
                      </span>
                    </div>

                    <!-- Status badge -->
                    <span class="text-[10px] px-2 py-0.5 rounded-full font-medium flex-shrink-0"
                      [ngClass]="getStatusClasses(schedule.status)">
                      {{ schedule.status }}
                    </span>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

</div>
